module.exports = {
  "meetingsLibLoaded": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": [
        "public",
        "embedded"
      ]
    },
    "namespace": "meetings"
  },
  "meetingsLibViewScreen": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": [
        "public",
        "embedded"
      ],
      "stage": "string"
    },
    "namespace": "meetings"
  },
  "meetingsLibClickPromoLink": {
    "name": "click viral link",
    "class": "interaction",
    "properties": {
      "page": "string"
    },
    "namespace": "meetings"
  },
  "meetingsLibSetProperty": {
    "name": "Set meeting property",
    "class": "interaction",
    "properties": {
      "property": "string",
      "value": "string"
    },
    "namespace": "meetings"
  },
  "meetingsLibTroubleshoot": {
    "name": "troubleshoot",
    "class": "interaction",
    "properties": {
      "action": "string"
    },
    "namespace": "meetings"
  },
  "meetingsLibViralityExperiment": {
    "name": "meetingsviralityexperiment",
    "class": "interaction",
    "properties": {
      "action": [
        "view",
        "click",
        "error"
      ],
      "variation": [
        "control",
        "variant",
        "default",
        "error",
        "timeout"
      ]
    },
    "namespace": "meetings"
  },
  "meetingsViralityPageView": {
    "name": "meetingsviralityexperiment",
    "class": "interaction",
    "properties": {
      "action": "string"
    },
    "namespace": "meetings"
  },
  "meetingEventInteraction": {
    "name": "meetingEventInteraction",
    "class": "interaction",
    "properties": {
      "action": [
        "clicked reschedule",
        "clicked cancel",
        "viewed reschedule",
        "viewed cancel"
      ],
      "source": {
        "type": "string"
      }
    },
    "namespace": "meetings"
  }
};